import { CLICKSTREAM_ERROR_HEARTBEAT } from './clickStream.constant';
import { addClickstreamEvent } from './clickStreamEventService';

let counter = 0;
export const increaseErrorCount = () => {
  counter += 1;
};

export const syncApiErrors = (interval: number) => {
  return setInterval(() => {
    addClickstreamEvent(
      CLICKSTREAM_ERROR_HEARTBEAT.LONGHORN_USER_HEARTBEAT,
      {
        errorCount: counter
      },
      true
    );
    counter = 0;
  }, interval);
};
